import React, { useEffect, useState } from 'react';
import { manejoAlertas } from '../Lib/funciones';
import '../styles/dado.css';
import ReactHowler from 'react-howler';
import sonidoDadosMP3 from '../sounds/Sonido_dados.mp3';


export default function Dado(props) {
    //Creamos el estado de transicion y de transformacion y los establecemos en un valor predefinido estos estados se modificaran cada vez que demos click en el dado ya que se ejecutara la funcion y necesitamos que esos parametros se establezcan nuevamente
    const [ transition, setTransition ] = useState(0);
    const [ transform, setTransform ] = useState(`translateY(400px) rotateX(0deg) rotateY(0deg) rotateZ(0deg)`);
    const [ sonidoDados, setSonidoDados ] = useState(false);
    const [turno, setTurno] = useState("rgba(0, 0, 0, 0.884) 0.3vw solid");


    //Funcion que cambia el color del dado para que se pinte con el turno actual.
    const cambiarColorDado = () => {
        if(props.turnoActual === 1){
            setTurno("rgba(17, 0, 255, 0.884) 0.3vw solid");
        }else if(props.turnoActual === 2){
            setTurno("rgba(255, 0, 0, 0.884) 0.3vw solid");
        }else if(props.turnoActual === 3){
            setTurno("rgba(30, 255, 0, 0.884) 0.3vw solid");
        }else if(props.turnoActual === 4){
            setTurno("rgba(255, 251, 0, 0.884) 0.3vw solid");
        }
    }


    //Creamos un useEffect que compruebe si hay un turno para saltar y se demore mas en pintar el dado y no lo haga inmediatamente.
    useEffect(() => {
        if(props.saltarTurnoDado === true){
            setTimeout(() => {
                cambiarColorDado()
            }, 4500);
        }else if(props.saltarTurnoDado === false){
            cambiarColorDado();
        }
    }, [props.turnoActual])


    //Esta linea esta comentada ya que no funciona en REACT por que es manipulacion directa del DOM
    //const cube = document.querySelector('.cube');
    const time = 2;


    //Establecemos la funcion que se ejecutara al hacer click sobre el dado.
    const ejecutarAnimacion = () => {
        if(props.botonIniciarJuego === true ){
            if(props.validarTirada === -100){
                setSonidoDados(true);
                setTimeout(() => {
                    setSonidoDados(false);
                }, 2100);
                //los estados creados fuera de la funcion los seteamos cada vez que demos click dentro de la funcion con valores predeterminados para que cada vez que demos click en el dado el ejecute su animacion correctamente es decir en (setTransform) establecemos el dado en una posicion inicial y cuando se ejecute el resto de la funcion independientemente de si el dado esta en cualquier cara el volvera a su lado incial y hara la transicion a cualquiera de las caras elegidas, sin estas lineas el arrancaria a rotar desde la cara en la que estaria actualmente y si el vuelve a caer el numero no rotaria por lo que es necesario establecer de nuevo estos valores.
                setTransform(`translateY(400px) rotateX(0deg) rotateY(0deg) rotateZ(0deg)`);
                setTransition("");
                //En estas lineas de abajo es como venia el codigo original de javascript puro donde se toman los estilos y se modifican desde el codigo directamente accediendo a ellos esto no funcionaba en REACT por lo que opte por crear el parametro style en la etiqueta (dado__div--cubo) donde uso los estados establecidos anteriormente para darles el estilo correspondiente establecido mas abajo en la estructura switch y seteandolos en los estados anteriormente expuestos.
                //cube.style.transition = '';
                //cube.style.transform = `translateY(400px) rotateX(0deg) rotateY(0deg) rotateZ(0deg)`;

                //Establecemos un setTimeout ... despues establecemos estado setTransition con un transform de 2 segundos, donde usamos la constante time creada en la linea 12 llamada time.
                //Despues establecemos una constante llamada randomValue donde obtendremos un valor aleatorio de 1 a 6 y posteriormente haremos un log en consola de ese dato para ver que coincida con la parte grafica.
                //Posteriormente creamos una estructura switch que toma cada caso y muestra al frente del dado el valor que se genero en la constante randomValue este se establece guardando en el estado setTransform el valor correpondiente al caso y aplicandolo en la hoja de estilos y con el tiempo de transicion establecido en 2 segundos es lo que durara la animacion del dado girando hasta mostrar el resultado graficamente.
                setTimeout(() => {
                    setTransition(`transform ${time}s`);
                    const randomValue = Math.floor((Math.random() * 6) + 1);
                    //Pasamos a la funcion prop el valor del dado para mandarlo al componente principal y si poder operar alli con el resultado.
                    props.fValorDado(randomValue, true);

                    // eslint-disable-next-line default-case
                    switch(randomValue) {
                        case 1:
                            setTransform(`translateY(400px) rotateX(3600deg) rotateY(3600deg) rotateZ(3600deg)`);
                            break;
                        case 2:
                            setTransform(`translateY(400px) rotateX(4410deg) rotateY(3600deg) rotateZ(3600deg)`);
                            break;
                        case 3:
                            setTransform(`translateY(400px) rotateX(3600deg) rotateY(4410deg) rotateZ(3600deg)`);
                            break;
                        case 4:
                            setTransform(`translateY(400px) rotateX(3600deg) rotateY(2430deg) rotateZ(3600deg)`);
                            break;
                        case 5:
                            setTransform(`translateY(400px) rotateX(2430deg) rotateY(3600deg) rotateZ(3600deg)`);
                            break;
                        case 6:
                            setTransform(`translateY(400px) rotateX(3600deg) rotateY(1980deg) rotateZ(3600deg)`);
                            break;
                    };
                }, time * 10);
            }else{
                manejoAlertas(props.setEstadoAlerta, props.setMensajeAlerta, "Termina tu turno", 0, 3000);
                // alert("Termina tu turno");
                console.log(props.turnoActual);
            }
        } else {
            manejoAlertas(props.setEstadoAlerta, props.setMensajeAlerta, "Comienza el juego para lanzar el dado", 0, 3000);
            // alert("Comienza el juego para lanzar el dado.");
        }
        }







    return (
    <div className="dado__div dado__div--contenedor">
        <ReactHowler src={sonidoDadosMP3} playing={sonidoDados} />
        <div className="dado__div--cubo" onClick={() => ejecutarAnimacion()} style={{transform: transform, transition: transition}}>
            <div className="cubo__cara cubo__cara--frente" style={{border: turno}}>
                <div className="inside">
                    <span className="punto"></span>
                </div>
            </div>
            <div className="cubo__cara cubo__cara--atras" style={{border: turno}}>
                <div className="inside">
                    <span className="punto"></span>
                    <span className="punto"></span>
                    <span className="punto"></span>
                    <span className="punto"></span>
                    <span className="punto"></span>
                    <span className="punto"></span>
                </div>
            </div>
            <div className="cubo__cara cubo__cara--izquierda" style={{border: turno}}>
                <div className="inside">
                    <span className="punto"></span>
                    <span className="punto"></span>
                    <span className="punto"></span>
                </div>
            </div>
            <div className="cubo__cara cubo__cara--derecha" style={{border: turno}}>
                <div className="inside">
                    <span className="punto"></span>
                    <span className="punto"></span>
                    <span className="punto"></span>
                    <span className="punto"></span>
                </div>
            </div>
            <div className="cubo__cara cubo__cara--arriba" style={{border: turno}}>
                <div className="inside">
                    <span className="punto"></span>
                    <span className="punto"></span>
                    <span className="punto"></span>
                    <span className="punto"></span>
                    <span className="punto"></span>
                </div>
            </div>
            <div className="cubo__cara cubo__cara--abajo" style={{border: turno}}>
                <div className="inside">
                    <span className="punto"></span>
                    <span className="punto"></span>
                </div>
            </div>
        </div>
    </div>
    )
}
